import React, { useState, useEffect } from "react"
import _ from "lodash"

import { NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { InputText_s } from "styles/input-styles"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const InputTypeDetailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyItem = {
    year: 1,
    renewalProbability: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i: 0}]);
  const [data, setData] = useState<object|null>({...props.rowData[props.field]})

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data)
    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    setData(newData)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    strippedItems.map((item, i) => item.year = i+1);
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    props.persist(newData, 'renewalprobabilitydetail', props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    strippedItems.map((item, i) => item.year = i+1);
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed'){
      _.set(newData, 'state', 'detailed')
    }
    props.persist(newData, 'renewalprobabilitydetail', props.rowData)
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'detailed'){
      setItems([{...emptyItem, i: 0}]);
    } else {
      setData({...props.rowData[props.field]});
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('renewalProbability', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('renewalProbability', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      { renderItems.map((row:object, i) => (
        <MultiRowCarouselState_s className="carousel-multi-row">
          <div>
            { i === 0 && <label>Year</label> }
            <InputText_s readOnly value={i+1} className="year-input" />
          </div>
          <div>
            { i === 0 && <label>Renewal Probability</label> }
            <NumberInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'renewalProbability']} {...params} readPrecision={2} writePrecision={2} min={0} max={100} />
          </div>
          <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
        </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default InputTypeDetailed
